import Product from '@/finsight/domain/Product';
import { getQueryStringParams } from '@/Framework/url/helpers/queryString';
import { validateUrlFilter } from '@/finsight/application/actions/pageFilters/productRegionFilters/actions';
import { IgetValidChangeProductsRes } from './types';
import { IProduct } from '@/finsight/domain/vo/Product';
import { IRegion } from '@/finsight/domain/vo/Region';
import Region from '@/finsight/domain/Region';

interface IHeaderData {
  productsCollection: IProduct[],
  regionsCollection: IRegion[],
}
// TODO refactror after redux state ts coverage
export const getValidChangedProducts = (state: any, headerData: IHeaderData): IgetValidChangeProductsRes => {
  const {
    router: { location: { pathname, ...location } },
  } = state;
  const {
    products: urlProducts,
    regions: urlRegions,
  } = getQueryStringParams(location);

  const {
    updatedQuery: validProducts,
    hasChanged: productsChanged,
  } = validateUrlFilter(urlProducts, headerData.productsCollection, Product.getDefaultProductByPath(pathname));

  const {
    updatedQuery: validRegions,
    hasChanged: regionsChanged,
  } = validateUrlFilter(urlRegions, headerData.regionsCollection, Region.getDefault());

  return {
    pathname,
    validProducts,
    validRegions,
    productsChanged,
    regionsChanged,
  };
};
